/** Keys for the clinician portal's screen-data cache (see useCachedQuery). */
export const clinicianQueryKeys = {
  queue: "clinician:queue",
  mine: "clinician:mine",
  reviewItem: (id: string) => `clinician:review-item:${id}`,
  queuePreview: (id: string) => `clinician:queue-preview:${id}`,
};
